import ts from 'typescript';
import { NodeCompiler } from '../NodeCompiler';
export class ThisExpressionCompiler extends NodeCompiler {
    constructor() {
        super(...arguments);
        this.kind = ts.SyntaxKind.ThisKeyword;
    }
    visitNode(sb, expr, options) {
        if (options.pushValue) {
            sb.scope.getThis(sb, expr, options);
        }
    }
}

//# sourceMappingURL=ThisExpressionCompiler.js.map
